// The GTM Tracker guide (50_GtmTracker.jsx · ModuleHelp, Max 01/11).
const en = {
  kpisT: 'Progress at a glance',
  kpisB: 'How many approved programmes there are, how many of their steps are done, and how many are in progress or overdue.',
  overdueT: 'Overdue',
  overdueB: 'A step is overdue when its expected date has passed and it is not done. Click this card to list only the programmes with a late step.',
  toolsT: 'Search',
  toolsB: 'Search reads the code, the name, the owner and the steps. Clear resets the search, the overdue filter and every column filter.',
  tableT: 'The approved programmes',
  tableB: 'One row per programme with its progress bar, overdue count and next step. Programmes with a late step come first; use the funnel on a header to filter.',
  foldT: 'Open the steps',
  foldB: 'Click a row or its arrow to see the programme\'s steps. If you may edit, change a step\'s status here as it moves from Not started to In progress to Done.',
};
const ko = {
  kpisT: '진행 현황 한눈에',
  kpisB: '승인된 프로그램 수, 완료된 단계 수, 진행 중 또는 기한이 지난 단계 수입니다.',
  overdueT: '기한 초과',
  overdueB: '예정일이 지났는데 완료되지 않은 단계가 기한 초과입니다. 이 카드를 클릭하면 지연 단계가 있는 프로그램만 보입니다.',
  toolsT: '검색',
  toolsB: '검색은 코드, 이름, 담당자, 단계를 찾습니다. 지우기는 검색, 기한 초과 필터, 열 필터를 모두 초기화합니다.',
  tableT: '승인된 프로그램',
  tableB: '프로그램당 한 행으로 진행률 막대, 기한 초과 건수, 다음 단계가 나옵니다. 지연 단계가 있는 프로그램이 먼저 나오며, 머리글의 깔때기로 필터링합니다.',
  foldT: '단계 열기',
  foldB: '행이나 화살표를 클릭하면 프로그램의 단계가 보입니다. 편집 권한이 있으면 시작 전, 진행 중, 완료로 단계 상태를 여기서 바꿉니다.',
};
const vi = {
  kpisT: 'Tiến độ trong một cái nhìn',
  kpisB: 'Có bao nhiêu chương trình đã duyệt, bao nhiêu bước đã xong, và bao nhiêu bước đang làm hoặc quá hạn.',
  overdueT: 'Quá hạn',
  overdueB: 'Một bước quá hạn khi ngày dự kiến đã qua mà chưa xong. Bấm thẻ này để chỉ liệt kê các chương trình có bước trễ.',
  toolsT: 'Tìm kiếm',
  toolsB: 'Ô tìm kiếm đọc mã, tên, người phụ trách và các bước. Nút Xóa lọc đặt lại tìm kiếm, bộ lọc quá hạn và mọi bộ lọc cột.',
  tableT: 'Các chương trình đã duyệt',
  tableB: 'Mỗi dòng là một chương trình kèm thanh tiến độ, số bước quá hạn và bước tiếp theo. Chương trình có bước trễ nằm trên cùng; dùng biểu tượng phễu ở tiêu đề cột để lọc.',
  foldT: 'Mở các bước',
  foldB: 'Bấm vào dòng hoặc mũi tên để xem các bước của chương trình. Nếu có quyền sửa, bạn đổi trạng thái từng bước tại đây: Chưa bắt đầu, Đang làm, Xong.',
};
const zh = {
  kpisT: '进度一览',
  kpisB: '已批准方案的数量、已完成的步骤数,以及进行中和已逾期的步骤数。',
  overdueT: '已逾期',
  overdueB: '步骤的预计日期已过但尚未完成,即为逾期。点击此卡片只列出有逾期步骤的方案。',
  toolsT: '搜索',
  toolsB: '搜索会查找编号、名称、负责人和步骤。清除会重置搜索、逾期筛选和所有列筛选。',
  tableT: '已批准的方案',
  tableB: '每个方案一行,显示进度条、逾期数和下一步。有逾期步骤的方案排在前面;用列标题上的漏斗进行筛选。',
  foldT: '展开步骤',
  foldB: '点击该行或箭头可查看方案的各个步骤。如果你有编辑权限,可在这里把步骤状态从未开始改为进行中、再改为已完成。',
};
const dictionary = { ns: 'tourGtmTracker', en, ko, vi, zh };
export default dictionary;
